import styled from '@emotion/styled';
import {
  spacing,
  pageContentWidth,
  pageContentWithSidebarWidth,
} from '$variables/theme';

export const PageWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const PageContainer = styled.div`
  flex-grow: 1;
  padding-top: ${({ paddingTop }) => `${paddingTop}px`};

  @media (max-width: ${pageContentWithSidebarWidth}) {
    margin-left: 0;
    padding-right: ${spacing.xSmall};
    padding-left: ${spacing.xSmall};
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: center;
  max-width: ${pageContentWidth};
  overflow-y: auto;
`;
